import React, { useState, useEffect, useRef } from "react";
import logo from "../assets/img/logo.png";
import calling from "../assets/img/Calling.svg";
import clock from "../assets/img/Time Circle.svg";
import Address from "../assets/img/address.svg";
import mail from "../assets/img/Message.svg";
import facebook from "../assets/img/Facebook.svg";
import instagram from "../assets/img/Instagram.svg";
import twitter from "../assets/img/twitter-48.svg";
import Youtube from "../assets/img/youtube.svg";
import Pinterest from "../assets/img/pinterest.svg";
import ftLines from "../assets/img/ft-lines.png";
import packageJson from "../../package.json";
import { Link, useNavigate } from "react-router-dom";
const BASE_URL = packageJson.apiUrl;
const SITE_URL = packageJson.siteUrl;
const Footer = ({ footerData }) => {
  const handleClick = (text) => {
    localStorage.setItem("categoryName", text);
  };
const [categories, setCategories] = useState([]);
 useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${BASE_URL}/category/list`);
        const data = await response.json();
        if (data.success) {
          setCategories(data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  return (
    <footer className="m-footer">
      <div className="container-xl">
        <div className="row">
          <div className="col-lg-3 col--md-3 col-12">
            <img src={logo} className="img-fluid ft-logo" alt="logo" />
            <p className="ft-ab">Endorse Learning <br/> Where Skills Meet Opportunity.</p>
			
          </div>
          <div className="col-lg-3 col--md-3 col-12">
            <h5 className="ft-title">Categories</h5>
            <ul className="ft-link-list list-unstyled">
             
			   {categories.map((category) => (
                    <li key={category.id}>
                      <a href={`/category/course/${category.id}`}>
  {category.category}
</a>
                    </li>
                  ))}
            </ul>
          </div>
          <div className="col-lg-3 col--md-3 col-12">
            <h5 className="ft-title">Support</h5>
            <ul className="ft-link-list list-unstyled">
              <li>
                <a href="/terms" onClick={() => handleClick("Terms")}>
                  Terms & Conditions
                </a>
              </li>
              <li>
                <a
                  href="/privacy-policies"
                  onClick={() => handleClick("Privacy Policies")}
                >
                  Privacy & Policies
                </a>
              </li>
              <li>
                <a href="/faq" onClick={() => handleClick("FAQ")}>Help & FAQ’s</a>
              </li>
              <li>
                <a href="/contact" onClick={() => handleClick("Contact Us")}>Contact Us</a>
              </li>
            </ul>
          </div>
          <div className="col-lg-3 col--md-3 col-12">
            <h5 className="ft-title">Connect With Us</h5>
            <ul className="address-list list-unstyled">
              <li>
                <img src={calling} className="img-fluid" alt="" />
                {footerData?.Call}
              </li>
              <li>
                <img src={clock} className="img-fluid" alt="" /> Response hours:{" "}
                {footerData?.responce_time}
              </li>
              <li>
                <img src={Address} className="img-fluid" alt="" />
                {footerData?.Address}
              </li>
              <li>
                <img src={mail} className="img-fluid" alt="" />
                {footerData?.Email}
              </li>
            </ul>
            <ul className="list-inline list-social">
              <li className="list-inline-item">
                <a href={footerData?.Facebook} target="_blank" rel="noreferrer">
                  <img src={facebook} className="img-fluid" alt="" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href={footerData.Instagram} target="_blank" rel="noreferrer">
                  <img src={instagram} className="img-fluid" alt="" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href={footerData.Pinterest} target="_blank" rel="noreferrer">
                  <img src={Pinterest} className="img-fluid" alt="" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href={footerData.Twitter} target="_blank" rel="noreferrer">
                  <img src={twitter} className="img-fluid" alt="" />
                </a>
              </li>
              <li className="list-inline-item">
                <a href={footerData.Youtube} target="_blank" rel="noreferrer">
                  <img src={Youtube} className="img-fluid" alt="" />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="ft-bottom text-center">
        <p>all copyright (c) 2024 reserved</p>
      </div>
      <img src={ftLines} className="img-fluid ft-lines" alt="" />
    </footer>
  );
};

export default Footer;
